import LocaleService from '@services/LocaleService';
import {
  SignOutIcon,
  EditProfileIcon,
  NavPersonIcon,
  ClinicProfileIcon,
  PlansPaymentIcon,
  SettingsIcon,
  TutorialVideosIcon,
} from '@shared/icons';

const i18n = LocaleService.getTranslations('navigation');

const profileMenus = {
  dentist: [
    {
      title: i18n.button.edit_profile,
      icon: <EditProfileIcon />,
      key: 'edit_profile',
    },
    {
      title: i18n.button.my_clinics,
      icon: <ClinicProfileIcon />,
      key: 'my_clinics',
    },
    {
      title: i18n.button.notification_settings,
      icon: <SettingsIcon />,
      key: 'notification_settings',
    },
    {
      title: i18n.button.my_plans,
      icon: <PlansPaymentIcon />,
      key: 'my_plans',
    },
    {
      title: i18n.button.tutorial,
      icon: <TutorialVideosIcon />,
      key: 'tutorial_videos',
    },
    {
      title: i18n.button.sign_out,
      icon: <SignOutIcon />,
      key: 'sign_out',
    },
  ],
  'dental-clinic': [
    {
      title: i18n.button.edit_profile,
      icon: <EditProfileIcon />,
      key: 'edit_profile',
    },
    {
      title: i18n.button.my_dentists,
      icon: <NavPersonIcon />,
      key: 'my_dentists',
    },
    {
      title: i18n.button.notification_settings,
      icon: <SettingsIcon />,
      key: 'notification_settings',
    },
    {
      title: i18n.button.my_plans,
      icon: <PlansPaymentIcon />,
      key: 'my_plans',
    },
    {
      title: i18n.button.tutorial,
      icon: <TutorialVideosIcon />,
      key: 'tutorial_videos',
    },
    {
      title: i18n.button.sign_out,
      icon: <SignOutIcon />,
      key: 'sign_out',
    },
  ],
  laboratory: [
    {
      title: i18n.button.edit_profile,
      icon: <EditProfileIcon />,
      key: 'edit_profile',
    },
    {
      title: i18n.button.notification_settings,
      icon: <SettingsIcon />,
      key: 'notification_settings',
    },
    {
      title: i18n.button.tutorial,
      icon: <TutorialVideosIcon />,
      key: 'tutorial_videos',
    },
    {
      title: i18n.button.sign_out,
      icon: <SignOutIcon />,
      key: 'sign_out',
    },
  ],
};

export default profileMenus;
